
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leolux-landing",
      function () {
        return require("private-next-pages/leolux-landing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leolux-landing"])
      });
    }
  